import { Pipe, PipeTransform } from '@angular/core';

import { Account } from '@accounts/models/account';

@Pipe({
  name: 'accountDisplayName',
  standalone: true
})
export class AccountDisplayNamePipe implements PipeTransform {
  transform(account: Account, initialsOnly = false): string {
    if (!account) {
      return '';
    }

    return initialsOnly
      ? this.getInitials(account)
      : `${account.firstName ?? ''} ${account.lastName ?? ''}`.trim();
  }

  private getInitials(account: Account): string {
    const first = account.firstName?.trim()?.[0] ?? '';
    const last = account.lastName?.trim()?.[0] ?? '';
    return `${first}${last}`.trim();
  }
}
